import * as React from 'react';

interface PieUsageTableProps {
  rows: Record<any, any>[];
}
export const PieUsageTable = ({ rows }: PieUsageTableProps) => (
  <table className="pie-usage-table">
    <thead>
      <tr>
        <td>Type</td>
        <td># of Segments</td>
      </tr>
    </thead>
    <tbody>{rows}</tbody>
  </table>
);
